// Contato.js — a página /contato.
//
// REFEITA EM 18/10/2026 no desenho dos outros dois sites: a abertura com a
// grade de pontos e o título na League Gothic, e embaixo os canais como
// cartões (ladrilho com o ícone, rótulo, o endereço e a ação). Antes era a
// marca grande à esquerda e três linhas soltas à direita.
//
// Os endereços continuam saindo de config/contato.js: o e-mail e o telefone
// do cabeçalho e daqui são a mesma escrita.
import React from "react";
import { Link } from "react-router-dom";

import {
  EMAIL_CONTATO,
  EMAIL_CONTATO_HREF,
  TELEFONE_TEXTO,
  TELEFONE_HREF,
  WHATSAPP_HREF,
  WHATSAPP_PUBLICAR_HREF,
} from "../../config/contato";
import { CabecalhoDePagina, TituloDeSecao } from "../ui/TituloDeSecao";
import Reveal from "../ui/Reveal";

const main = process.env.REACT_APP_MAIN;

const CANAIS = [
  {
    icone: "bi-whatsapp",
    rotulo: "WhatsApp",
    valor: TELEFONE_TEXTO,
    texto: "O jeito mais rápido: dúvidas sobre livros, pedidos, Clube e publicação.",
    acao: "Abrir conversa",
    href: WHATSAPP_HREF,
    externo: true,
  },
  {
    icone: "bi-envelope-at",
    rotulo: "E-mail",
    valor: EMAIL_CONTATO,
    texto: "Para enviar arquivos, propostas e o que precisa ficar por escrito.",
    acao: "Escrever e-mail",
    href: EMAIL_CONTATO_HREF,
  },
  {
    icone: "bi-telephone",
    rotulo: "Telefone",
    valor: TELEFONE_TEXTO,
    texto: "De segunda a sexta, em horário comercial.",
    acao: "Ligar agora",
    href: TELEFONE_HREF,
  },
];

const ATALHOS = [
  { icone: "bi-patch-question", titulo: "Dúvidas frequentes", texto: "As respostas que mais pedem, e a Layla para conversar.", para: "faq" },
  { icone: "bi-book-half", titulo: "Todo o catálogo", texto: "Os livros da editora, com prévia e as duas versões.", para: "livros" },
  { icone: "bi-stars", titulo: "Clube Insigne", texto: "O acervo inteiro de e-books por uma assinatura.", para: "clube" },
];

function Contato() {
  return (
    <div className="bg-insigne-bg min-h-screen pt-[var(--nav-h)] pb-16 text-white">
      <CabecalhoDePagina
        chapeu="Fale com a editora"
        titulo="Estamos a uma mensagem de você"
        destaque="uma mensagem"
        lead="Atendimento direto com a equipe da Insigne Acadêmica: pedidos, Clube, dúvidas sobre um livro ou a publicação da sua obra."
      >
        <a
          href={WHATSAPP_PUBLICAR_HREF}
          target="_blank"
          rel="noreferrer"
          className="btn-solido foco-laranja inline-flex items-center gap-2 rounded-controle px-5 py-3 text-sm font-bold"
        >
          <i className="bi bi-whatsapp" aria-hidden="true" /> Fale com o editor-chefe
        </a>
      </CabecalhoDePagina>

      <section className="mx-auto max-w-[1280px] px-4 py-[3rem] md:px-8">
        <ul className="grid grid-cols-1 gap-5 md:grid-cols-3">
          {CANAIS.map((c, i) => (
            <li key={c.rotulo}>
              <Reveal delay={i * 0.06} className="h-full">
                <a
                  href={c.href}
                  target={c.externo ? "_blank" : undefined}
                  rel={c.externo ? "noreferrer" : undefined}
                  className="cartao cartao-clique foco-laranja flex h-full flex-col p-[1.5rem] text-white no-underline"
                >
                  <span className="ladrilho text-xl">
                    <i className={"bi " + c.icone} aria-hidden="true" />
                  </span>
                  <span className="mt-[1.1rem] text-[11px] font-extrabold uppercase tracking-[0.16em] text-white/45">{c.rotulo}</span>
                  <span className="mt-[0.25rem] text-[1.05rem] font-bold text-white [overflow-wrap:anywhere]">{c.valor}</span>
                  <span className="mt-[0.5rem] text-sm leading-relaxed text-white/60">{c.texto}</span>
                  <span className="mt-auto inline-flex items-center gap-2 pt-[1rem] text-sm font-bold text-insigne-orange">
                    {c.acao} <i className="bi bi-arrow-right" aria-hidden="true" />
                  </span>
                </a>
              </Reveal>
            </li>
          ))}
        </ul>
      </section>

      <section className="mx-auto max-w-[1280px] px-4 md:px-8">
        <Reveal>
          <TituloDeSecao chapeu="Antes de escrever" titulo="Talvez a resposta já esteja aqui" destaque="já esteja aqui" />
        </Reveal>
        <ul className="mt-[2rem] grid grid-cols-1 gap-4 md:grid-cols-3">
          {ATALHOS.map((a) => (
            <li key={a.para}>
              <Link
                to={main + a.para}
                onClick={() => window.scrollTo({ top: 0 })}
                className="foco-laranja flex h-full items-start gap-4 rounded-card border-2 border-insigne-sombra bg-insigne-navy-deep p-4 text-white no-underline transition-colors hover:border-insigne-orange/60"
              >
                <i className={"bi " + a.icone + " mt-[0.1rem] text-xl text-insigne-orange"} aria-hidden="true" />
                <span className="min-w-0">
                  <span className="block font-bold">{a.titulo}</span>
                  <span className="mt-[0.2rem] block text-sm leading-relaxed text-white/55">{a.texto}</span>
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}

export default Contato;
